module.exports = __webpack_public_path__ + "img/resource-example.2c3991a1.jpg";